import { FETCH_CONFERENCE_STARTED, FETCH_CONFERENCE_DONE, FETCH_CONFERENCE_FAILED } from '../actions/actionTypes'

const initialState = {
  documents: [],
  fetching: false,
  error: ''
}

export const conferences = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONFERENCE_STARTED: {
      return {
        ...state,
        fetching: true
      }
    }
    case FETCH_CONFERENCE_DONE: {
      return {
        ...state,
        documents: action.payload.data.documents,
        fetching: false
      }
    }
    case FETCH_CONFERENCE_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
